import { useRouter } from 'next/router'
import { useState } from 'react'
import { useCurrentUser } from '../../../../../modules/context/UserContext'
import { STUDENT_BTN_ID } from '../../../../../modules/ids/gtm/student'
import { sendHomeSectionClickEvent } from '../../../helpers/HomeHelpers'
import { IHomeFaqItem } from '../../../interface/home.interface'

type FaqListItemProps = {
  faq: IHomeFaqItem
}

const FaqListItem: React.FC<FaqListItemProps> = ({ faq }) => {
  const { currentUser } = useCurrentUser()

  const router = useRouter()

  const [isOpen, setIsOpen] = useState(false)

  const handleClickItem = (faqQuestion: string) => {
    sendHomeSectionClickEvent(
      STUDENT_BTN_ID.CLICK_SECTION_FAQ,
      `FAQ ${isOpen ? '닫기' : '열기'} - ${faqQuestion}`,
      currentUser,
      router,
      undefined,
      null
    )

    setIsOpen((prev) => !prev)
  }

  const handleClickActionLabel = (faqActionLabel: string, faqActionLink: string) => {
    sendHomeSectionClickEvent(
      STUDENT_BTN_ID.CLICK_SECTION_FAQ,
      `FAQ 링크 클릭 - ${faqActionLabel}`,
      currentUser,
      router,
      undefined,
      null
    )

    window.open(faqActionLink, '_blank')
  }

  return (
    <div className="w-full py-32">
      <div
        className="flex min-w-[600px] cursor-pointer items-center justify-between"
        onClick={() => handleClickItem(faq.question)}
      >
        <span className="text-[18px] font-medium leading-[160%] text-[#000000]">{faq.question}</span>
        <i className={`fe text-18 font-bold ${isOpen ? ' fe-chevron-up' : ' fe-chevron-down'}`} />
      </div>

      {isOpen && (
        <div className="mt-12 rounded-[8px] bg-[#F8F8FB] p-32">
          {/* FAQ Answer */}
          <p className="text-[18px] font-medium leading-[160%] text-[#000000]">{faq.answer}</p>

          {/* FAQ Action Text */}
          {faq.actionLabel && (
            <button
              className="mt-20 flex items-center text-purple-500"
              onClick={() => handleClickActionLabel(faq.actionLabel, faq.actionLink)}
            >
              <span className="text-16 font-bold leading-[160%]">{faq.actionLabel}</span>
              <i className="fe fe-chevron-right text-18 ml-2" />
            </button>
          )}
        </div>
      )}
    </div>
  )
}

export default FaqListItem
